// Tracking GTM dei click sulle CTA "Richiedi demo" del layout 2026.
// Stato avanzamento: vedi docs/2026-gtm-form-tracking.md
//
// Tutte le CTA puntano all'ancora #cta (scroll al form in fondo alla pagina) e
// sono marcate nel markup con data-cta="<posizione>" (hero, nav, banner, shift_1..4,
// statement, come, mid, finale). Il click da solo non è una conversione: è un segnale
// di intento che dice QUALE blocco della pagina spinge verso il form.
//
// La pagina di origine (cta_page) riusa il campo hidden 'type' del form di contatto,
// presente su ogni pagina 2026, così la nomenclatura coincide con form_location.
//
// Evento nel dataLayer:
//   cta_click — click su un elemento [data-cta]

(function () {
    var triggers = document.querySelectorAll('[data-cta]');
    if (!triggers.length) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    var typeField = document.querySelector('form.cta-form input[name="type"]');
    var ctaPage = typeField ? typeField.value : 'unknown';

    triggers.forEach(function (el) {
        el.addEventListener('click', function () {
            window.dataLayer.push({
                event: 'cta_click',
                cta_position: el.getAttribute('data-cta') || 'unknown',
                cta_page: ctaPage,
                page_path: window.location.pathname,
                language: document.documentElement.lang || 'it',
            });
        });
    });
})();
